module.exports = {
  lang: {
    t1: `首页`,
    t2: `名片`,
    t3: `关注`,
    t4: `联系人`,
    t5: `消息`,
    t6: `登录`,
    t7: `注册`,
    t8: `全球商务互联新平台，企业数字营销新阵地`,
    t9: `手机号登录`,
    t10: `手机号`,
    t11: `验证码`,
    t12: `请输入手机号`,
    t13: `请输入验证码`,
    t14: `获取`,
    t15: `登录`,
    t16: `请输入正确格式的手机号`,
    t17: `验证码已发送`,
    t18: `验证码输入有误，请核对后重新输入`,
    t19: `登录成功`,
    t20: `您的验证码是(0)，请在{1}分钟内使用。`,
    t21: `取消`,
    t22: `确认`,
    t23: `温馨提示`,
    t24: `您的WeMeet账户注册尚未完成。现在就行动起来，完成注册流程，畅享多元互动与无限可能。`,
    t25: `前往注册`,
    t26: `WeMeet邮箱登录`,
    t27: `账号名`,
    t28: `请输入邮箱`,
    t29: `密码`,
    t30: `请输入密码`,
    t31: `忘记密码？`,
    t32: `登录`,
    t33: `其他登录方式`,
    t34: `已经注册WeMeet小程序？使用`,
    t35: `手机号登录`,
    t36: `请先输入邮箱`,
    t37: `请先输入密码`,
    t38: `邮箱地址格式不正确`,
    t39: `如您已有WeMeet账号，可直接`,
    t40: `登录`,
    t41: `头像`,
    t42: `请上传真实头像`,
    t43: `姓名`,
    t44: `名`,
    t45: `姓`,
    t46: `机构名称`,
    t47: `请填写您所在机构名称`,
    t48: `职务`,
    t49: `请填写您所在机构的职务名称`,
    t50: `邮箱`,
    t51: `请输入邮箱`,
    t52: `手机号`,
    t53: `请输入手机号`,
    t54: `地区`,
    t55: `请选择地区`,
    t56: `区域`,
    t57: `请选择省市区`,
    t58: `地址`,
    t59: `请填写地址`,
    t60: `已阅读并同意WeMeet`,
    t61: `《服务条款》`,
    t62: `《隐私政策》`,
    t63: `继续`,
    t64: `请先阅读并同意WeMeet用户协议`,
    t65: `请填写名字`,
    t66: `请填写姓`,
    t67: `请先填写邮箱`,
    t68: `请先填写机构名称`,
    t69: `邮箱地址格式不正确`,
    t70: `取消`,
    t71: `完成`,
    t72: `验证手机`,
    t73: `手机号`,
    t74: `验证码`,
    t75: `请输入验证码`,
    t76: `获取`,
    t77: `跳过验证`,
    t78: `提交`,
    t79: `验证通过`,
    t80: `验证码输入有误，请核对后重新输入`,
    t81: `已跳过`,
    t82: `温馨提示`,
    t83: `您输入的手机号已注册WeMeet账号。无需重复注册，现在就直接登录。`,
    t84: `前往登录`,
    t85: `温馨提示`,
    t86: `您输入的邮箱已注册WeMeet账号。无需重复注册，现在就直接登录。`,
    t87: `前往登录`,
    t88: `验证链接已发送`,
    t89: `请查看邮箱，点击链接完成注册。`,
    t90: `知道了`,
    t91: `欢迎加入WeMeet`,
    t92: `欢迎加入WeMeet，请您点击按钮完成注册。温馨提醒：此链接有效期为24小时，请尽快操作。`,
    t93: `完成注册`,
    t94: `邮箱已激活，请输入密码`,
    t95: `输入密码`,
    t96: `请输入密码`,
    t97: `确认密码`,
    t98: `请再次输入密码`,
    t99: `包含大小写字母、数字、特殊字符的组合，长度在8-20位之间`,
    t100: `请输入密码`,
    t101: `请再次输入密码`,
    t102: `密码不一致`,
    t103: `恭喜您注册完成`,
    t104: `已为您登录WeMeet，您可以继续之前的操作`,
    t105: `继续体验`,
    t106: `温馨提示`,
    t107: `链接已失效，请点击按钮重新获取。`,
    t108: `重新发送`,
    t109: `服务条款`,
    t110: `隐私政策`,
    t111: `找回密码`,
    t112: `请输入您要找回密码的账号`,
    t113: `账号名`,
    t114: `请输入邮箱`,
    t115: `提交`,
    t116: `请先输入邮箱`,
    t117: `邮箱地址格式不正确`,
    t118: `邮件已发送`,
    t119: `请查看邮箱，点击链接，重新设置密码。`,
    t120: `知道了`,
    t121: `重置密码-WeMeet`,
    t122: `您的密码重置请求已被确认，系统已生成一个临时密码重置链接。温馨提醒：此链接有效期为24小时，请尽快操作。`,
    t123: `重置密码`,
    t124: `密码重置成功`,
    t125: `已为您登录WeMeet，欢迎您回来。`,
    t126: `前往首页`,
    t127: `联系人`,
    t128: `新的联系人申请`,
    t129: `同意`,
    t130: `忽略`,
    t131: `已同意`,
    t132: `已忽略`,
    t133: `我关注`,
    t134: `被关注`,
    t135: `消息`,
    t136: `未处理请求`,
    t137: `请输入姓名或者手机号`,
    t138: `没有匹配的内容`,
    t139: `没有更多了哦`,
    t140: `联系人申请`,
    t141: `同意`,
    t142: `忽略`,
    t143: `已同意`,
    t144: `已忽略`,
    t145: `AI荟客厅`,
    t146: `已关注`,
    t147: `已取消关注`,
    t148: `vCard`,
    t149: `添加联系人`,
    t150: `发消息`,
    t151: `等待通过`,
    t152: `解除联系人`,
    t153: `个人介绍`,
    t154: `个人履历`,
    t155: `温馨提示`,
    t156: `您的联系人申请已发送，通过后将自动为您关注TA。您也可以先关注TA，了解更多信息。`,
    t157: `暂不关注`,
    t158: `关注`,
    t159: `已关注`,
    t160: `解除联系人关系`,
    t161: `解除联系人关系后,对方无法查看您的个人信息，但不会同时取消关注。`,
    t162: `再考虑一下`,
    t163: `解除联系人`,
    t164: `操作成功`,
    t165: `WeMeet AI助理`,
    t166: `请输入您的问题`,
    t167: `发送`,
    t168: `请注意AI互动内容可能有误,不代表平台观点。`,
    t169: `WeMeet名片`,
    t170: `下载`,
    t171: `编辑名片`,
    t172: `下载二维码`,
    t173: `图片已生成，请保存。扫描二维码保存联系人。`,
    t174: `头像`,
    t175: `请上传真实头像`,
    t176: `姓名`,
    t177: `名`,
    t178: `姓`,
    t179: `请输入姓名`,
    t180: `机构名称`,
    t181: `请填写您所在机构名称`,
    t182: `职务`,
    t183: `请填写您所在机构的职务名称`,
    t184: `邮箱`,
    t185: `请输入邮箱`,
    t186: `手机号`,
    t187: `请输入手机号`,
    t188: `地区`,
    t189: `请选择地区`,
    t190: `区域`,
    t191: `请选择省市区`,
    t192: `地址`,
    t193: `请填写地址`,
    t194: `请填写名字`,
    t195: `请填写姓`,
    t196: `请先填写邮箱`,
    t197: `请先填写机构名称`,
    t198: `邮箱地址格式不正确`,
    t199: `聊天室`,
    t200: `照片`,
    t201: `拍照`,
    t202: `请输入消息`,
    t203: `发送`,
    t204: `已读`,
    t205: `未读`,
    t206: `已过撤回时限`,
    t207: `取消`,
    t208: `照片`,
    t209: `相簿`,
    t210: `拍摄`,
    t211: `从相册选择`,
    t212: `取消`,
    t213: `照片`,
    t214: `人像`,
    t215: `预览`,
    t216: `完成`,
    t217: `AI荟客厅`,
    t218: `联系我们`,
    t219: `请联系我`,
    t220: `姓名`,
    t221: `机构`,
    t222: `职位`,
    t223: `电话`,
    t224: `邮箱`,
    t225: `地区`,
    t226: `区域`,
    t227: `地址`,
    t228: `请填写您的姓名`,
    t229: `请填写您的机构名称`,
    t230: `请填写您的职位`,
    t231: `请填写手机号码`,
    t232: `请填写您的邮箱地址`,
    t233: `请选择地区`,
    t234: `请选择省市区`,
    t235: `请输入地址`,
    t236: `意向`,
    t237: `采购产品`,
    t238: `代理产品`,
    t239: `市场合作`,
    t240: `其他`,
    t241: `请填写您的姓名`,
    t242: `请填写您的机构名称`,
    t243: `请填写您的邮箱地址`,
    t244: `邮箱地址格式不正确`,
    t245: `留言已提交`,
    t246: `留言`,
    t247: `请输入您要咨询的内容`,
    t248: `确认`,
    t249: `请先进行登录注册`,
    t250: `关注`,
    t251: `联系我们`,
    t252: `产品`,
    t253: `团队`,
    t254: `概况介绍`,
    t255: `相册资料`,
    t256: `资质信息`,
    t257: `注册资本`,
    t258: `成立日期`,
    t259: `注册地址`,
    t260: `上游`,
    t261: `中游`,
    t262: `下游`,
    t263: `配套`,
    t264: `工艺`,
    t265: `保存`,
    t266: `已验证`,
    t267: `中文`,
    t268: `英语`,
    t269: `法语`,
    t270: `俄语`,
    t271: `西班牙语`,
    t272: `日语`,
    t273: `韩语`,
    t274: `印度尼西亚语`,
    t275: `越南语`,
    t276: `德语`,
    t277: `土耳其语`,
    t278: `意大利语`,
    t279: `葡萄牙语`,
    t280: `泰语`,
    t281: `马来语`,
    t282: `阿拉伯语`,
    t283: `账号密码不正确`,
    t284: `请先阅读并同意WeMeet用户协议`,
    t285: `暂无相关内容`,
    t286: `类型`,
    t287: `属性`,
    t288: `详情`,
    t289: `其他`,
    t290: `共2个产品`,
    t291: `{1}邀请您访问{2}的AI荟客厅`,
    t292: `您可以点击下方示例，或者输入问题：`,
    t293: `换一批`,
    t294: `您还可以点击下方名片，添加联系人了解更多：`,
    t295: `点击了解`,
    t296: `WeMeet数字办会`,
    t297: `WeMeet数字办展`,
    t298: `WeMeet个人名片和AI荟客厅`,
    t299: `如何成为WeMeet机构会员`,
    t300: `WeMeet数字办会服务为您提供全面的线上会议解决方案，包括但不限于会议创建与发布、参会人员报名管理、电子签到、会议日程安排、会议材料共享、实时互动讨论以及嘉宾互动等。通过使用WeMeet数字办会功能，您可以便捷高效地组织和管理各类会议活动，无论是小型内部会议还是大型峰会，都能实现数字化、智能化的办会体验。
点击小程序底部菜单栏中间“+”的“办个会”按钮，即刻开启您的数字办会之旅。`,
    t301: `WeMeet数字办展，助力快速搭建展会微官网。展示展商信息、展品介绍、展会直播、展会注册、活动日程等内容，让参展企业和观众轻松了解展会详情。如需使用数字办展功能，请先完成机构入驻。点击“我的”，下拉页面至“服务中心” - “机构入驻”并根据提示完成入驻流程。`,
    t302: `WeMeet个人用户只需授权微信号、手机号并完成平台注册后，即可获得个人数字名片，并可维护个人AI荟客厅（包含个人履历、动态、照片、文档等）。点击小程序底部菜单栏“我的”，完成个人名片页的更新及个人主页的完善。`,
    t303: `点击“我的”，下拉页面至“服务中心”，点击“机构入驻”并根据提示完成入驻流程。`,
    t304: `包含大小写字母、数字、标点符号的组合，长度在8-20位之间。`,
    t305: `输入产品名称`,
    t306: `没有更多了`,
    t307: `点击右上角`,
    t308: `选择你喜欢的方式分享`,
    t309: `我知道了`,
    t310: `请先完成注册登录`,
    t311: `了解更多`,
    t312: `关联产品`,
    t313: `感谢您的来访`,
    t314: `退出登录`,
    t315: `关注机构`,
    t316: `上一页`,
    t317: `下一页`,
    t318: `没有`,
    t319: `{1}邀请您访问{2}的详情`,
    t320: `AI荟客厅暂未维护当前语言`,
    t321: `AI荟客厅已切换到当前语言`,
    t322: `该链接已被激活`,
    t323: `网络繁忙，请稍后再试`,
    t324: `产品详情已切换到当前语言`,
    t325: `产品详情暂未维护当前语言`,
    t326: `您好，我是WeMeet智能AI助理，随时为您提供贴心服务！请问有什么可以帮到您？`,
    t327: `请输入机构名称`,
    t328: `我找到了相关的联系人信息，请查看下面的联系人卡片。`,
    t329: `附件`,
    t330: `我没有找到相关的联系人信息。`,
    t331: `我已将您的问询转发给以下这位负责同事，您也可以点击名片马上联系。`,
    t332: `展会`,
    t333: `请输入`,
    t334: `用户`,
    t335: `暂无更多数据`,
    t336: `刷新成功`,
    t337: `玩命加载中`,
    t338: `释放即可刷新`,
    t339: `验证码已经失效`,
    t340: `加载中`,
    t341: `消息翻译`,
    t342: `是否开启消息翻译？`,
    t343: `开启后，自动将对方发送的文本消息，翻译所选语言，并展示在消息原文的下方。`,
    t344: `不超过500字`,
    t345: `上传中`,
    t346: `文件`,
    t347: `当前上传文件类型不符合要求`,
    t348: `是否关闭消息翻译？`,
    t349: `关闭后，将不再翻译对方的发送的文本消息。`,
    t350: `确定`,
    t351: `已复制`,
    t352: `网络信号微弱，网页加载可能会受到影响，您可以尝试刷新页面或稍后再试。`,
    t353: `刷新页面`,
    t354: `发送失败`,
    t355: `请选择语言`,
    t356: `产品`,
    t357: `展会`,
    t358: `场馆`,
    t359: `岗位`,
    t360: `请输入关键词`,
    t361: `列表`,
    t362: `性别`,
    t363: `男`,
    t364: `女`,
    t365: `地区`,
    t366: `手机号`,
    t367: `公司/机构`,
    t368: `职位`,
    t369: `邮箱`,
    t370: `部门`,
    t371: `单选`,
    t372: `多选`,
    t373: `姓名`,
    t374: `性别`,
    t375: `请选择地区`,
    t376: `请输入`,
    t377: `添加图片`,
    t378: `点击上传文件`,
    t379: `证件类型`,
    t380: `请填写证件号码`,
    t381: `居民身份证`,
    t382: `中华人民共和国居民身份证`,
    t383: `回乡证`,
    t384: `港澳居民来往内地通行证`,
    t385: `台胞证`,
    t386: `台湾居民来往大陆通行证`,
    t387: `居住证`,
    t388: `台湾居民居住证`,
    t389: `护照`,
    t390: `报名通过`,
    t391: `取消报名`,
    t392: `您提交的报名已通过审核，请出示入场码入场`,
    t393: `查看我的报名信息`,
    t394: `出示我的入场码`,
    t395: `您已报名，我们将尽快完成审核，审核结果将会通过短信告知您。`,
    t396: `审核不通过`,
    t397: `很抱歉，您申请的证件未审核通过。`,
    t398: `查看原因，并重新填写表单！`,
    t399: `失败原因`,
    t400: `确定`,
    t401: `报名审核中`,
    t402: `报名成功`,
    t403: `审核不通过`,
    t404: `回到首页`,
    t405: `证件类型`,
    t406: `证件号码`,
    t407: `证件照片`,
    t408: `请选择省市区`,
    t409: `请选择证件类型`,
    t410: `开始`,
    t411: `结束`,
    t412: `并重新填写表单！`,
    t413: `查看原因`,
    t414: `重新报名`,
    t415: `取消成功！`,
    t416: `请填写正确的邮箱`,
    t417: `证件号码长度不能低于6位`,
    t418: `已更新报名信息`,
    t419: `请完成问题`,
    t420: `请先勾选用户协议`,
    t421: `报名入口暂未开放`,
    t421: `验证码已失效`,
    t422: `已签到`,
    t423: `未签到`,
    t424: `实名认证不通过`,
    t425: `实名认证不通过,请输入正确的姓名`,
    t426: `实名认证不通过,请上传证件照片`,
    t427: `未配置该身份报名设置`,
    t428: `请报名进行中的会议`,
    t429: `仅限展会观众报名`,
    t430: `报名入口暂未开放`,
    t431: `您已经是展会嘉宾 无须报名`,
    t432: `身份类型未配置`,
    t433: `请上传证件照片`,
    t434: `更新`,
    t435: `请输入邀请码`,
    t436: `此邀请码不存在或无法使用`,
    t437: `请填写邀请码`,
    t438: `报名通道未开启`,
    t869: `铂瑞厅A+B`,
    t870: `铂瑞厅C`,
    t871: `多功能厅`,
    t872: `会议室9+10`,
    t873: `会议室2+3`,
    t874: `会议室12`,
    t875: `会议室11`,
    t876: `会议室1`,
    t877: `会议室5`,
    t878: `会议室6`,
    t879: `会议室8`,
    t880: `发布空间`,
    t881: `互动空间A `,
    t882: `互动空间B `,
    t883: `互动空间C`,
    t884: `互动空间D`,
    t885: `互动空间E`,
    t886: `互动空间F`,
    t887: `会场地图`,
    t888: `铂瑞酒店2楼会议室平面图`,
    t889: `绿地贸易港3楼互动空间平面图`,
    t890: `查看3D地图`,
    t891: `请先阅读并同意用户协议 `,
    t892: `已阅读并同意进博会上海会议活动`,
    t893: `很抱歉，报名名额已满`,
    t943: `很抱歉，您已在这个时间段内报名过其他会议，您无法再报名本场会议。`,

    t547: `提示`,
    t954: `您已提交过表单内容，是否需要一键报名本场会议？`,
    t955: `一键报名`,
  },
};
